import React from 'react';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { IGalleryData } from '../../types/api/galleryApi';
import { NoData } from '../common/NoData';

// Define the type for the component's props
interface MasonryGalleryProps {
    images: Array<IGalleryData>;
}

const MasonryGallery: React.FC<MasonryGalleryProps> = ({ images }) => {
    return (
        <div>
            <section className='gallary-section'>
                <div className='container'>
                    <div className="masonry-gallery">
                        <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
                            <Masonry>
                                {images && images.length > 0 ?
                                    images.map((image, index) => (
                                        <div className="masonry-item" key={"mansory_image_" + index} style={{ padding: '8px' }}>
                                            <img
                                                src={image.photo}
                                                alt={`Gallery item ${index + 1}`}
                                            />
                                        </div>
                                    ))
                                    : <NoData message='Oops,No gallery data founcd!!' />
                                }
                            </Masonry>
                        </ResponsiveMasonry>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MasonryGallery;
